export function setClientDeviceCookies() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  try {
    const resolution = `${window?.screen?.width}x${window?.screen?.height}`
    document.cookie = `screenResolution=${resolution}; path=/;`

    const deviceInfo = {
      userAgent: navigator?.userAgent,
      platform: navigator?.platform,
      language: navigator?.language,
      vendor: navigator?.vendor,
      resolution,
      hardwareConcurrency: navigator?.hardwareConcurrency,
      deviceMemory: (navigator as any)?.deviceMemory,
      maxTouchPoints: navigator?.maxTouchPoints,
    }

    const encoded = encodeURIComponent(JSON.stringify(deviceInfo))
    document.cookie = `deviceDetails=${encoded}; path=/;`
  } catch (err) {
    // eslint-disable-next-line
    console.warn('Failed to set device cookies:', err)
  }
}
